import { Component, inject, Input } from '@angular/core';
import { BasicTableComponent } from '@common/references/basic-table.component';
import { DatePipe, NgForOf, NgIf } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { Table } from '@primeng/table';
import { Observable } from 'rxjs';
import { PageResult } from '@shared/components/classes/page-result';
import { SharedModule } from '@primeng/api';
import { ModalClose } from '@shared/services/modal/modal.enum';
import { InvoicesService } from '@modules/universal-billing/billing/invoice/invoices.service';

@Component({
  selector: 'app-resident-invoices',
  standalone: true,
  imports: [
    DatePipe,
    NgForOf,
    NgIf,
    TranslatePipe,
    Table,
    SharedModule
  ],
  templateUrl: './resident-invoices.component.html',
  styleUrl: './resident-invoices.component.scss'
})
export class ResidentInvoicesComponent extends BasicTableComponent<any> {
  @Input() residentId: number;
  service = inject(InvoicesService);
  addQueryToUrl = false;
  getAll(params: any): Observable<PageResult<any>> {
    params.residentId = this.residentId;
    return super.getAll(params);
  }
  onAdd() {
    this.modalService.open({
      component: this.service.formComponent,
      title: this.translateService.instant('DASHBOARD.ADDINVOICE'),
      componentOptions: {
        _defaultService: this.service,
        residentId: this.residentId
      },
      modalOptions: this.service?.formModalOptions ?? {}
    }).then(value => {
      if (value == ModalClose.SUCCESS) {
        this.loadData();
      }
    })
  }

  onEdit(data: any) {
    this.modalService.open({
      component: this.service.formComponent,
      title: this.translateService.instant('INVOICES.EDIT_ITEM'),
      componentOptions: {
        selectedRow: data,
        residentId: this.residentId,
        isEdit: true,
        _defaultService: this.service
      },
      modalOptions: this.service?.formModalOptions ?? {}
    }).then((res) => {
      if (res == ModalClose.SUCCESS) {
        this.loadData();
      }
    }).catch((err) => {})
  }
}
